import { useTranslation } from "react-i18next";

import { CASE_LADDER, type CaseLadderStep } from "../services/mapCentinelaCase";
import { CASE_LADDER_ICONS } from "../theme";

export interface CaseLadderProps {
  step: CaseLadderStep;
  attempts: number;
  maxAttempts: number | null;
}

export default function CaseLadder({ step, attempts, maxAttempts }: CaseLadderProps) {
  const { t } = useTranslation("common");

  if (step === "resuelto") {
    return (
      <span className="flex items-center gap-1.5 font-mono text-[10px] max-sm:text-[11px] uppercase tracking-wider text-success">
        <i className={`${CASE_LADDER_ICONS.resuelto} text-[11px]`} />
        {t("monitoreoIa.monitoringCenter.ladder.resuelto")}
      </span>
    );
  }

  const current = CASE_LADDER.indexOf(step);

  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1">
        {CASE_LADDER.map((mark, index) => (
          <span
            key={mark}
            title={t(`monitoreoIa.monitoringCenter.ladder.${mark}`)}
            className={`h-[3px] flex-1 rounded-full ${
              index < current ? "bg-success/60" : index === current ? "bg-warning" : "bg-subtle"
            }`}
          />
        ))}
      </div>
      <p className="flex items-center gap-1.5 font-mono text-[10px] max-sm:text-[11px] uppercase tracking-wider text-content-muted">
        <i className={`${CASE_LADDER_ICONS[step]} text-[11px]`} />
        {t(`monitoreoIa.monitoringCenter.ladder.${step}`)}
        {attempts > 0 ? (
          <span className="text-content-faint">
            ·{" "}
            {maxAttempts
              ? t("monitoreoIa.monitoringCenter.attemptOf", {
                  current: attempts,
                  total: maxAttempts,
                })
              : t("monitoreoIa.monitoringCenter.attempt", { count: attempts })}
          </span>
        ) : null}
      </p>
    </div>
  );
}
